// An offer checked against the window the patient asked for.
//
// Carla wrote "I am free the week of Oct 19th" and was texted a lab draw on
// Tuesday 13 October. The set button had been pressed from the panel's
// default day before her reply was read; her reply moved the date, a second
// press added the right set, and both stayed in the offer. Nothing compared
// the offer with her words. This does, in one sentence under the offer.
//
// Only times before the START of the window are named. The parser's end is
// a guess at the month's end — Carla's own "Nov 6 and 9th" fell after it —
// so a time after the end is not a mistake the panel can be sure of.
import { offerWhen, OfferSlot } from './offerMessage';
import { RequestedWindow } from './requestedAppointmentWindow';
import { dayLabel } from './offerSteps';

const pad = (n: number) => String(n).padStart(2, '0');
const isoDay = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const firstName = (full?: string | null) => String(full || '').trim().split(/\s+/)[0] || '';

export function windowWarnings(
  offered: OfferSlot[],
  window: RequestedWindow | null | undefined,
  patientName?: string | null,
): string[] {
  if (!window || !offered.length) return [];
  const start = isoDay(window.start);
  const early = offered
    .filter((s) => String(s.date || '').slice(0, 10) < start)
    .sort((a, b) => `${a.date}${a.time}`.localeCompare(`${b.date}${b.time}`))
    .map(offerWhen);
  if (!early.length) return [];
  const who = firstName(patientName) || 'The patient';
  const list = early.length === 1 ? early[0] : `${early.slice(0, -1).join(', ')} and ${early[early.length - 1]}`;
  const verb = early.length === 1 ? 'is' : 'are';
  const advice = early.length === 1 ? 'Remove it unless they said it works.' : 'Remove them unless they said those work.';
  return [`${who} asked for ${dayLabel(start)} or later — ${list} ${verb} before that. ${advice}`];
}
